export default __webpack_public_path__ + "static/media/Office 1 OFD.140607d6.jpg";